import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full md:w-1/3 xl:w-1/4" }
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = {
  key: 1,
  class: "text-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "animate-pulse text-gray-600 text-xl font-medium" }, " Processando... ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fr_alert = _resolveComponent("fr-alert")!
  const _component_fr_button = _resolveComponent("fr-button")!
  const _component_FrLoading = _resolveComponent("FrLoading")!
  const _component_centered_layout = _resolveComponent("centered-layout")!

  return (_openBlock(), _createBlock(_component_centered_layout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.processing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_fr_alert, {
                type: _ctx.notification.type
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.notification.message), 1)
                ]),
                _: 1
              }, 8, ["type"]),
              _createVNode(_component_fr_button, {
                link: "",
                to: { name: 'SignIn' },
                color: _ctx.notification.type == 'error' ? 'red-600' : 'green-600'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('signup.click_here_text')), 1)
                ]),
                _: 1
              }, 8, ["color"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_FrLoading, {
                size: "20",
                tickness: "8"
              }),
              _hoisted_4
            ]))
      ])
    ]),
    _: 1
  }))
}